/*
 * For the env system to work, DEPLOY_ENV, TARGET, and NODE_ENV must be defined on `process.env` in the runtime build.
 * Currently these are set via webpack.DefinePlugin in each individual build.
 *
 * Do not reference process.env values directly elsewhere in code, use the exports from this module instead!
 */

export const VALID_DEPLOY_ENVS = ['production', 'unstable', 'stable', 'sandbox', 'tilt', 'test'] as const;
export type DeployEnvironment = typeof VALID_DEPLOY_ENVS[number];

export type Target = 'browser' | 'node';
export type NodeEnvValue = 'production' | 'development';

export const DEPLOY_ENV = process.env.DEPLOY_ENV as DeployEnvironment;

if (!VALID_DEPLOY_ENVS.includes(DEPLOY_ENV)) {
  throw new Error(`process.env.DEPLOY_ENV must be set to a valid environment: ${VALID_DEPLOY_ENVS}`);
}

export const NODE_ENV = process.env.NODE_ENV as NodeEnvValue;

/**
 * Variables based on deploy environment
 */
interface DeployEnvSettings {
  ENABLE_CRITEO: boolean;
}

const deployEnvVars: Record<DeployEnvironment, DeployEnvSettings> = {
  production: {
    ENABLE_CRITEO: true,
  },
  sandbox: {
    ENABLE_CRITEO: false,
  },
  stable: {
    ENABLE_CRITEO: false,
  },
  unstable: {
    ENABLE_CRITEO: true,
  },
  tilt: {
    ENABLE_CRITEO: false,
  },
  test: {
    ENABLE_CRITEO: false,
  },
};

export const {
  ENABLE_CRITEO,
} = deployEnvVars[DEPLOY_ENV];
